<template  >
  <v-container fluid class="pa-0 blue-background">
    <section v-cloak>
      <v-parallax :src="require('@/assets/banner-4-copy.png')" height="768">
        <v-toolbar class="transparent flat" flat>
          <v-spacer></v-spacer>
          <v-toolbar-items class>
            <v-btn flat class="blue-text" >Home</v-btn>
            <v-btn flat class="blue-text" @click="dialogTodo = true">Help</v-btn>
            <v-btn flat class="blue-text" @click="dialogTodo = true">Login</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout
          column
          align-start
          :class="[{'pl-5': $vuetify.breakpoint.mdAndUp}, {'pl-2': $vuetify.breakpoint.sm}]"
          class="white--text"
        >
          <h1 class="white--text mb-2 display-2 font-weight-black pl-5">RESILIENT RESIDENCE</h1>
          <h1
            class="white--text mb-2 headline text-xs-center pl-5 hidden-sm-and-down blue-text"
          >Protect your most precious asset!</h1>
          <div
            class="white--text mb-2 headline text-xs-center pl-5 hidden-sm-and-down blue-text"
          >Over 20,000 Queenslanders have tried it. Are you next?</div>
          <!--
          <div>title: {{title}}</div>
          <div>queryData: {{queryData}}</div>
          <div>version: {{queryData && queryData.version}}, old {{queryData && queryData.previous && queryData.previous.version}}</div>
          -->
          <v-layout
            
            text-center
            row
            pl-5
          >
            <div class="text-xs-center">
            <v-btn
              class="mt-2 blue-text yellow-background"
              dark
              large
              round
              to='survey'
            >Get Started</v-btn>
            </div>
          </v-layout>
        </v-layout>
      </v-parallax>
    </section>

    <LandingMenu></LandingMenu>
    <Neighbourhood></Neighbourhood>

    <section>
      <About></About>
    </section>

    <PageFooter></PageFooter>

    <v-dialog v-model="dialogTodo" max-width="500px">
      <v-card class="white-background">
        <v-card-title>
          <span class="blue-text">TODO</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn
            class="mt-5 blue-text yellow-background"
            dark
            large
            round
            @click="dialogTodo=false"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
@import "../assets/styles/styles.css";
/*.v-stepper__step__step { color: rgb(25,118,210) !important }*/
</style>

<script>
import LandingMenu from "./LandingMenu.vue";
import Neighbourhood from "./Neighbourhood.vue";
import About from "./About.vue";
import PageFooter from "./PageFooter.vue";
// import { queryParser } from "../model/query-parser.js";

export default {
  name: 'home2',
  components: {
    LandingMenu,
    Neighbourhood,
    About,
    PageFooter
  },
  data() {
    return {
      title: "Resilient Residence",
      dialogTodo: false
    };
  },
  mounted() {
    // eslint-disable-next-line no-console
    // console.log('home2.mounted()');
  }
  /*,
  computed: {
    queryData() { return store.state.queryData; }
  }*/
};
</script>